import React from 'react'
import PropTypes from 'prop-types'
import s from 'underscore.string'
import { withAccordion } from '@unowmooc/buttons'
import { FormattedHTMLMessage } from 'react-intl'
import { withRouter } from 'react-router-dom'
import styled from '@emotion/styled'
import { colors, transitions } from 'styles-resources'
import { ZeroHeightDev } from '@unowmooc/zeroheight'

const StyledLink = styled.button`
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 48px;
  color: ${({ active }) => (active ? colors.black : colors.manatee)};
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: ${transitions.color};

  &:hover {
    color: ${colors.black};
    text-decoration: none;

    div {
      opacity: 1;
    }
  }

  div {
    opacity: ${({ active }) => (active ? 1 : 0.6)};
    transition: ${transitions.opacity};
  }
`

const Label = styled.span`
  margin-left: 18px;
  white-space: nowrap;
`

const Link = ({ hidden, to, domain, name, icon, location: { pathname }, ...props }) => {
  if (hidden) {
    return null
  }

  const active = new RegExp(`^${to}`).test(pathname)

  return (
    <StyledLink key={name} id="dropdown-button-project" active={active} {...props}>
      <ZeroHeightDev name={icon} height="32px" width="32px" active={active} />
      <Label>
        <FormattedHTMLMessage id={`menu.${domain}.${s.replaceAll(name, '-', '_')}`} />
      </Label>
    </StyledLink>
  )
}

Link.defaultProps = {
  location: undefined,
  domain: undefined,
  hidden: false,
}

Link.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
  to: PropTypes.string.isRequired,
  domain: PropTypes.string,
  component: PropTypes.func.isRequired, // eslint-disable-line react/no-unused-prop-types
  name: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  hidden: PropTypes.bool,
}
const Dropdown = withAccordion(withRouter(Link))

Dropdown.isDomainLayout = true

export default Dropdown
